import wrapReactLifecycleMethodsWithTryCatch, { config } from 'react-component-errors'
import stringify from 'json-stringify-safe'

import Raven from 'utils/raven'

config.errorHandler = errorReport => {
  Raven.captureException(errorReport.error, {
    component: errorReport.component,
    method: errorReport.method,
    props: stringify(errorReport.props),
  })
}

const errorHandler = Component => {
  wrapReactLifecycleMethodsWithTryCatch(Component)
  return Component
}

export default errorHandler



/** WEBPACK FOOTER **
 ** ./src/components/error-handler/error-handler.js
 **/